/* ===== DISLICORES: prioridad por stock de sucursal en búsqueda ===== */
(function () {
  'use strict';

  if (window.SucursalProductPriority) return;

  var STORAGE_KEY = 'sucursal_store';
  var INVENTORY_ENDPOINT = 'https://sioconn.dislicores.com/poligonos/inventory';
  var GIFT_CARD_TITLE = 'tarjetas de regalo';
  var GIFT_CARD_HANDLE = 'tarjetas-de-regalo';
  var MAX_CONCURRENT = 5;
  var availabilityCache = new Map();

  function normalizeText(value) {
    return String(value || '')
      .trim()
      .toLowerCase()
      .normalize('NFD')
      .replace(/[\u0300-\u036f]/g, '');
  }

  function normalizeProductId(value) {
    return String(value || '').split('/').pop();
  }

  function getState() {
    try {
      var raw = localStorage.getItem(STORAGE_KEY);
      return raw ? JSON.parse(raw) : null;
    } catch (e) {
      return null;
    }
  }

  function isGiftCard(card) {
    if (!card) return false;

    var title = card.querySelector('.product-card__title');
    if (title && normalizeText(title.textContent) === GIFT_CARD_TITLE) return true;

    var link = card.querySelector('a[href*="/products/"]');
    if (!link) return false;

    var href = link.getAttribute('href') || '';
    var match = href.match(/\/products\/([^/?#]+)/i);
    return !!(match && normalizeText(match[1]).replace(/\s+/g, '-') === GIFT_CARD_HANDLE);
  }

  function nativeUnavailable(card) {
    if (typeof card.__branchNativeUnavailable !== 'undefined') {
      return card.__branchNativeUnavailable;
    }

    var action = card.querySelector('.product-card__atc, .product-card__list-atc');
    var text = action ? normalizeText(action.textContent) : '';

    card.__branchNativeUnavailable = Boolean(
      action &&
      ((action.disabled === true && text) || text.indexOf('pronto de vuelta') !== -1)
    );

    return card.__branchNativeUnavailable;
  }

  function setCardUnavailable(card, unavailable) {
    if (!card) return;

    card.classList.toggle('is-branch-unavailable', unavailable);
    card.setAttribute('data-branch-available', unavailable ? 'false' : 'true');

    var quantities = card.querySelectorAll('.product-card__quantity');
    Array.prototype.forEach.call(quantities, function (quantity) {
      if (typeof quantity.__branchOriginalDisplay === 'undefined') {
        quantity.__branchOriginalDisplay = quantity.style.display || '';
      }
      quantity.style.display = unavailable ? 'none' : quantity.__branchOriginalDisplay;
    });

    var actions = card.querySelectorAll('.product-card__atc, .product-card__list-atc');
    Array.prototype.forEach.call(actions, function (action) {
      if (!action.__branchOriginalState) {
        action.__branchOriginalState = {
          html: action.innerHTML,
          href: action.getAttribute('href'),
          tabindex: action.getAttribute('tabindex'),
          ariaDisabled: action.getAttribute('aria-disabled'),
          pointerEvents: action.style.pointerEvents || '',
          disabled: action.disabled === true
        };
      }

      var original = action.__branchOriginalState;

      if (!unavailable) {
        action.innerHTML = original.html;

        if (original.href === null) action.removeAttribute('href');
        else action.setAttribute('href', original.href);

        if (original.tabindex === null) action.removeAttribute('tabindex');
        else action.setAttribute('tabindex', original.tabindex);

        if (original.ariaDisabled === null) action.removeAttribute('aria-disabled');
        else action.setAttribute('aria-disabled', original.ariaDisabled);

        action.style.pointerEvents = original.pointerEvents;

        if ('disabled' in action) action.disabled = original.disabled;

        action.classList.remove('is-branch-unavailable-action');
        return;
      }

      var label = action.querySelector(
        '.product-card__atc-text, .product-card__action-text, .btn__text'
      );

      if (label) label.textContent = '¡Pronto de vuelta!';
      else action.textContent = '¡Pronto de vuelta!';

      var icon = action.querySelector('.product-card__atc-icon, .product-card__action-icon');
      if (icon) icon.style.display = 'none';

      action.setAttribute('aria-disabled', 'true');
      action.setAttribute('tabindex', '-1');
      action.classList.add('is-branch-unavailable-action');

      if (action.tagName === 'A') {
        action.removeAttribute('href');
        action.style.pointerEvents = 'none';
      } else if ('disabled' in action) {
        action.disabled = true;
      }
    });
  }

  function fetchAvailability(productId, state) {
    var id = normalizeProductId(productId);
    if (!id || !state || !state.id) return Promise.resolve(null);

    var cacheKey = String(state.id) + ':' + id;
    if (availabilityCache.has(cacheKey)) {
      return Promise.resolve(availabilityCache.get(cacheKey));
    }

    var url =
      INVENTORY_ENDPOINT +
      '?locationId=' + encodeURIComponent(state.id) +
      '&productId=' + encodeURIComponent(id);

    return fetch(url, { headers: { Accept: 'application/json' } })
      .then(function (response) {
        if (!response.ok) throw new Error('HTTP ' + response.status);
        return response.json();
      })
      .then(function (data) {
        if (!data || !data.length) return null;

        var product = data[0];
        var title = normalizeText(product.title || product.name);
        var handle = normalizeText(product.handle).replace(/\s+/g, '-');

        if (title === GIFT_CARD_TITLE || handle === GIFT_CARD_HANDLE) {
          availabilityCache.set(cacheKey, true);
          return true;
        }

        var variants = Array.isArray(product.variants) ? product.variants : [];
        if (!variants.length) return null;

        var available = variants.some(function (variant) {
          return Number(variant.available || 0) > 0;
        });

        availabilityCache.set(cacheKey, available);
        return available;
      })
      .catch(function (error) {
        console.warn('[search-branch-priority] No se pudo validar producto ' + id, error);
        return null;
      });
  }

  function runLimited(items, worker) {
    var nextIndex = 0;
    var workers = [];
    var count = Math.min(MAX_CONCURRENT, items.length);

    function run() {
      var index = nextIndex++;
      if (index >= items.length) return Promise.resolve();

      return Promise.resolve(worker(items[index], index)).then(run);
    }

    for (var i = 0; i < count; i++) workers.push(run());
    return Promise.all(workers);
  }

  function getProductUnits(container) {
    return Array.prototype.filter.call(container.children, function (child) {
      if (child.matches && child.matches('[data-product-id]')) return true;
      return !!child.querySelector('[data-product-id]');
    });
  }

  function getCardFromUnit(unit) {
    if (unit.matches && unit.matches('[data-product-id]')) return unit;
    return unit.querySelector('[data-product-id]');
  }

  function reorderUnits(container) {
    var productUnits = getProductUnits(container);
    if (productUnits.length < 2) return;

    var ordered = productUnits.slice().sort(function (a, b) {
      var aCard = getCardFromUnit(a);
      var bCard = getCardFromUnit(b);
      var aUnavailable =
        aCard && aCard.getAttribute('data-branch-available') === 'false' ? 1 : 0;
      var bUnavailable =
        bCard && bCard.getAttribute('data-branch-available') === 'false' ? 1 : 0;
      return aUnavailable - bUnavailable;
    });

    var changed = ordered.some(function (node, index) {
      return node !== productUnits[index];
    });
    if (!changed) return;

    // Conserva artículos, páginas u otros nodos en su lugar y solamente cambia
    // el orden de los slots que pertenecen a productos.
    var slots = productUnits.map(function (unit) {
      var slot = document.createComment('search-product-slot');
      unit.parentNode.insertBefore(slot, unit);
      unit.remove();
      return slot;
    });

    ordered.forEach(function (unit, index) {
      slots[index].parentNode.insertBefore(unit, slots[index]);
    });

    slots.forEach(function (slot) { slot.remove(); });
  }

  function refreshContainer(container) {
    if (!container) return Promise.resolve();

    var state = getState();
    var requestId = (container.__branchPriorityRequest || 0) + 1;
    container.__branchPriorityRequest = requestId;

    var units = getProductUnits(container);
    var cards = units.map(getCardFromUnit).filter(Boolean);

    if (!cards.length) return Promise.resolve();

    // Sin sucursal dejamos el orden nativo, salvo los agotados globales que ya
    // vienen marcados por Shopify.
    if (!state || !state.id) {
      cards.forEach(function (card) {
        setCardUnavailable(card, nativeUnavailable(card));
      });
      reorderUnits(container);
      return Promise.resolve();
    }

    var results = new Array(cards.length);

    return runLimited(cards, function (card, index) {
      if (isGiftCard(card)) {
        results[index] = false;
        return;
      }

      var productId = card.getAttribute('data-product-id');
      return fetchAvailability(productId, state).then(function (available) {
        results[index] = available === false || nativeUnavailable(card);
      });
    }).then(function () {
      // Si el predictive fue reemplazado mientras consultábamos inventario,
      // descartamos esta respuesta para no ordenar contenido viejo.
      if (container.__branchPriorityRequest !== requestId || !container.isConnected) return;

      cards.forEach(function (card, index) {
        setCardUnavailable(card, Boolean(results[index]));
      });

      reorderUnits(container);
    });
  }

  function refreshWithin(root) {
    root = root || document;

    var containers = [];
    var selectors = [
      '#predictive-search-results-products-list',
      '.template-search #ProductsList'
    ];

    selectors.forEach(function (selector) {
      if (root.matches && root.matches(selector)) containers.push(root);
      Array.prototype.forEach.call(root.querySelectorAll ? root.querySelectorAll(selector) : [], function (el) {
        if (containers.indexOf(el) === -1) containers.push(el);
      });
    });

    return Promise.all(containers.map(refreshContainer));
  }

  window.SucursalProductPriority = {
    refreshContainer: refreshContainer,
    refreshWithin: refreshWithin,
    clearCache: function () { availabilityCache.clear(); }
  };
})();

class PredictiveSearch extends HTMLElement {
  constructor() {
    super();

    this.cachedMap = new Map();
    this.focusElement = this.input || null;
    this._vendors = null;
    this._searchConfig = null;
    this._synonymGroups = null;
    this._isSubmitting = false;

    if (this.resetButton) {
      this.resetButton.addEventListener('click', this.clear.bind(this));
    }

    if (this.input) {
      this.input.addEventListener(
        'input',
        FoxTheme.utils.debounce(this.onChange.bind(this), 300)
      );
      this.input.addEventListener('focus', this.onFocus.bind(this));
    }

    this.form = this.querySelector('form[role="search"]');
    this.form?.addEventListener('submit', this.onSubmit.bind(this));
    this.addEventListener('click', this.handleSearchKeywordClick.bind(this));

    this.searchContent = this.querySelector('.search__content');
    this.searchRecommendationEmpty = this.dataset.searchRecommendationEmpty === 'true';
    this.header = document.querySelector('header');
    this.toggleNavigationButton = document.querySelector('.toggle-navigation-button');

    this.boundHandleClickOutside = this.handleClickOutside.bind(this);
    document.addEventListener('click', this.boundHandleClickOutside);
    this.searchProductTypes?.addEventListener('change', this.handleProductTypeChange.bind(this));

    this.isHeaderSearch = this.closest('header') !== null;

    document.addEventListener('menu-drawer:open', () => {
      this.classList.remove('predictive-search-open');
      document.body.classList.remove('search-open');
    });

    this.states = {
      OPEN: 'predictive-search-open',
      LOADING: 'btn--loading',
      SEARCH_OPEN: 'search-open',
    };
  }

  get input() {
    return this.querySelector('input[type="search"]');
  }

  get resetButton() {
    return this.querySelector('button[type="reset"]');
  }

  get searchProductTypes() {
    return this.querySelector('#SearchProductTypes');
  }

  get vendors() {
    if (this._vendors !== null) {
      return this._vendors;
    }

    const vendorData = this.querySelector('[data-search-vendors]');

    if (!vendorData) {
      this._vendors = [];
      return this._vendors;
    }

    try {
      const parsed = JSON.parse(vendorData.textContent || '[]');
      this._vendors = Array.isArray(parsed) ? parsed.filter(Boolean) : [];
    } catch (error) {
      console.error('Error parsing search vendors:', error);
      this._vendors = [];
    }

    return this._vendors;
  }

  normalizeSearchValue(value) {
    return String(value || '')
      .normalize('NFD')
      .replace(/[\u0300-\u036f]/g, '')
      .replace(/\s+/g, ' ')
      .trim()
      .toLocaleLowerCase();
  }

  normalizeComparableSearchValue(value) {
    return this.normalizeSearchValue(value)
      .replace(/&/g, ' y ')
      .replace(/[._/\\-]+/g, ' ')
      .replace(/[^a-z0-9\s]/g, ' ')
      .replace(/\s+/g, ' ')
      .trim();
  }

  escapeSearchSyntaxValue(value) {
    return String(value || '')
      .replace(/\\/g, '\\\\')
      .replace(/"/g, '\\"');
  }

  get searchConfig() {
    if (this._searchConfig !== null) {
      return this._searchConfig;
    }

    const configData =
      this.querySelector('[data-dislicores-search-config]') ||
      document.querySelector('[data-dislicores-search-config]');

    if (!configData) {
      this._searchConfig = {
        synonyms: '',
        enableSku: false,
      };
      return this._searchConfig;
    }

    try {
      const parsed = JSON.parse(configData.textContent || '{}');

      this._searchConfig = {
        synonyms: typeof parsed.synonyms === 'string' ? parsed.synonyms : '',
        enableSku: parsed.enableSku === true,
      };
    } catch (error) {
      console.error('[Dislicores search] Error parsing search config:', error);
      this._searchConfig = {
        synonyms: '',
        enableSku: false,
      };
    }

    return this._searchConfig;
  }

  get skuSearchEnabled() {
    return this.searchConfig.enableSku === true;
  }

  parseSynonymGroups(value) {
    return String(value || '')
      .split(/\r?\n/)
      .map((line) =>
        line
          .split('|')
          .map((term) => term.trim())
          .filter(Boolean)
      )
      .filter((group) => group.length >= 2);
  }

  get synonymGroups() {
    if (this._synonymGroups !== null) {
      return this._synonymGroups;
    }

    this._synonymGroups = this.parseSynonymGroups(this.searchConfig.synonyms);
    return this._synonymGroups;
  }

  getSynonymGroup(query = this.getQuery()) {
    const normalizedQuery = this.normalizeComparableSearchValue(query);

    if (!normalizedQuery) {
      return null;
    }

    return (
      this.synonymGroups.find((group) =>
        group.some(
          (term) => this.normalizeComparableSearchValue(term) === normalizedQuery
        )
      ) || null
    );
  }

  getExactVendor(query = this.getQuery()) {
    const normalizedQuery = this.normalizeSearchValue(query);

    if (!normalizedQuery) {
      return null;
    }

    return (
      this.vendors.find(
        (vendor) => this.normalizeSearchValue(vendor) === normalizedQuery
      ) || null
    );
  }

  buildExactTitleTerm(value) {
    const normalized = this.normalizeComparableSearchValue(value);

    if (!normalized) {
      return '';
    }

    return `title:"${this.escapeSearchSyntaxValue(normalized)}"`;
  }

  shouldUseTitlePrefix(query) {
    const normalized = this.normalizeComparableSearchValue(query);
    const words = normalized.split(' ').filter(Boolean);

    if (!words.length) {
      return false;
    }

    return words[words.length - 1].length >= 4;
  }

  buildPrefixTitleTerm(value) {
    const normalized = this.normalizeComparableSearchValue(value);

    if (!normalized) {
      return '';
    }

    /*
     * Usamos el wildcard explícito de Shopify únicamente en el título.
     * Ejemplo: jage -> title:jage* -> Jagermeister.
     * Así el SKU sigue siendo una coincidencia exacta.
     */
    return `title:${this.escapeSearchSyntaxValue(normalized)}*`;
  }

  normalizeSkuValue(value) {
    return String(value || '')
      .trim()
      .replace(/\s+/g, ' ')
      .toLocaleLowerCase();
  }

  buildExactSkuTerm(value) {
    const normalized = String(value || '')
      .trim()
      .replace(/\s+/g, ' ');

    if (!normalized) {
      return '';
    }

    return `variants.sku:"${this.escapeSearchSyntaxValue(normalized)}"`;
  }

  buildTitleOnlyQuery(query, allowPrefix = false) {
    const normalized = this.normalizeComparableSearchValue(query);

    if (!normalized) {
      return '';
    }

    const words = normalized.split(' ').filter(Boolean);
    const lastIndex = words.length - 1;

    return words
      .map((word, index) => {
        /*
         * Las palabras anteriores siguen siendo completas.
         * Solo la última puede ser prefijo y únicamente desde 4 letras.
         */
        if (
          allowPrefix &&
          index === lastIndex &&
          word.length >= 4
        ) {
          return this.buildPrefixTitleTerm(word);
        }

        return this.buildExactTitleTerm(word);
      })
      .filter(Boolean)
      .join(' AND ');
  }

  buildTitleAndSkuQuery(query, allowPrefix = false) {
    const titleQuery = this.buildTitleOnlyQuery(query, allowPrefix);

    if (!this.skuSearchEnabled) {
      return titleQuery;
    }

    const skuQuery = this.buildExactSkuTerm(query);

    if (!titleQuery) {
      return skuQuery;
    }

    if (!skuQuery) {
      return titleQuery;
    }

    return `((${titleQuery}) OR ${skuQuery})`;
  }

  buildSynonymTitleQuery(group) {
    const terms = Array.from(
      new Set(
        (group || [])
          .map((term) => this.normalizeComparableSearchValue(term))
          .filter(Boolean)
      )
    );

    if (!terms.length) {
      return '';
    }

    const clauses = terms.map((term) => this.buildExactTitleTerm(term));

    return clauses.length > 1 ? `(${clauses.join(' OR ')})` : clauses[0];
  }

  buildSearchTerm(query = this.getQuery(), options = {}) {
    const synonymGroup = this.getSynonymGroup(query);
    const allowTitlePrefix = options.allowTitlePrefix === true;

    /*
     * Un sinónimo explícito tiene prioridad sobre la búsqueda por vendor.
     * Si no existe grupo de sinónimos, conservamos el comportamiento
     * anterior de marca/vendor exacta.
     */
    const exactVendor = synonymGroup ? null : this.getExactVendor(query);

    let searchTerm = '';

    if (synonymGroup) {
      searchTerm = this.buildSynonymTitleQuery(synonymGroup);
    } else if (exactVendor) {
      searchTerm = `vendor:"${this.escapeSearchSyntaxValue(exactVendor)}"`;
    } else {
      searchTerm = this.buildTitleAndSkuQuery(query, allowTitlePrefix);
    }

    if (this.searchProductTypes && this.searchProductTypes.value !== '') {
      const productType = this.escapeSearchSyntaxValue(this.searchProductTypes.value);
      searchTerm = `product_type:"${productType}" AND (${searchTerm})`;
    }

    return {
      exactVendor,
      synonymGroup,
      searchTerm,
    };
  }

  buildPredictiveSearchTerm(query = this.getQuery()) {
    const result = this.buildSearchTerm(query);
    const hasProductType = Boolean(
      this.searchProductTypes && this.searchProductTypes.value !== ''
    );

    /*
     * Para búsquedas normales mandamos el texto original al Predictive Search.
     * Así Shopify puede buscar en title + SKU y seguir sugiriendo colecciones.
     * Sinónimos, vendor y filtro de tipo sí necesitan la sintaxis construida.
     */
    if (result.synonymGroup || result.exactVendor || hasProductType) {
      return result;
    }

    return {
      ...result,
      searchTerm: query,
    };
  }

  levenshteinDistance(a, b) {
    const source = String(a || '');
    const target = String(b || '');

    if (source === target) return 0;
    if (!source.length) return target.length;
    if (!target.length) return source.length;

    let previous = Array.from({ length: target.length + 1 }, (_, index) => index);
    let current = new Array(target.length + 1);

    for (let i = 1; i <= source.length; i++) {
      current[0] = i;

      for (let j = 1; j <= target.length; j++) {
        const cost = source[i - 1] === target[j - 1] ? 0 : 1;

        current[j] = Math.min(
          current[j - 1] + 1,
          previous[j] + 1,
          previous[j - 1] + cost
        );
      }

      [previous, current] = [current, previous];
    }

    return previous[target.length];
  }

  isStrongCollectionMatch(query, collectionTitle) {
    const queryNormalized = this.normalizeComparableSearchValue(query);
    const titleNormalized = this.normalizeComparableSearchValue(collectionTitle);

    if (!queryNormalized || !titleNormalized) return false;
    if (queryNormalized === titleNormalized) return true;

    /*
     * Para similitud ignoramos espacios, pero mantenemos un umbral alto
     * para evitar redirects agresivos.
     */
    const queryCompact = queryNormalized.replace(/\s+/g, '');
    const titleCompact = titleNormalized.replace(/\s+/g, '');

    if (queryCompact === titleCompact) return true;

    const minLength = Math.min(queryCompact.length, titleCompact.length);
    const maxLength = Math.max(queryCompact.length, titleCompact.length);

    // No hacemos fuzzy redirect con términos demasiado cortos.
    if (minLength < 4) return false;

    const lengthDifference = Math.abs(queryCompact.length - titleCompact.length);
    const maxLengthDifference = Math.max(1, Math.floor(maxLength * 0.15));

    if (lengthDifference > maxLengthDifference) return false;

    const distance = this.levenshteinDistance(queryCompact, titleCompact);
    const similarity = 1 - distance / maxLength;

    let maxDistance = 1;
    let minSimilarity = 0.80;

    if (maxLength >= 7) {
      maxDistance = 2;
      minSimilarity = 0.84;
    }

    if (maxLength >= 14) {
      maxDistance = 3;
      minSimilarity = 0.86;
    }

    return distance <= maxDistance && similarity >= minSimilarity;
  }

  getCollectionCandidates(query = this.getQuery()) {
    const synonymGroup = this.getSynonymGroup(query);
    const values = [query].concat(synonymGroup || []);
    const seen = new Set();

    return values.filter((value) => {
      const normalized = this.normalizeComparableSearchValue(value);

      if (!normalized || seen.has(normalized)) {
        return false;
      }

      seen.add(normalized);
      return true;
    });
  }

  findBestCollectionMatch(collections, candidates) {
    if (!Array.isArray(collections) || !collections.length) return null;

    for (const candidate of candidates) {
      const exactMatch = collections.find(
        (collection) =>
          collection &&
          collection.title &&
          this.normalizeComparableSearchValue(collection.title) ===
            this.normalizeComparableSearchValue(candidate)
      );

      if (exactMatch) {
        return exactMatch;
      }
    }

    for (const candidate of candidates) {
      const fuzzyMatch = collections.find(
        (collection) =>
          collection &&
          collection.title &&
          this.isStrongCollectionMatch(candidate, collection.title)
      );

      if (fuzzyMatch) {
        return fuzzyMatch;
      }
    }

    return null;
  }

  findCollectionInRenderedPredictive(candidates) {
    const links = Array.from(
      this.querySelectorAll(
        '#predictive-search-results-collection-list a[href*="/collections/"]'
      )
    );

    const collections = links.map((link) => ({
      title: link.textContent.trim(),
      url: link.getAttribute('href'),
    }));

    return this.findBestCollectionMatch(collections, candidates);
  }

  async fetchCollectionSuggestions(query) {
    const root =
      window.Shopify && window.Shopify.routes && window.Shopify.routes.root
        ? window.Shopify.routes.root
        : '/';

    const url = new URL(`${root}search/suggest.json`, window.location.origin);

    url.searchParams.set('q', query);
    url.searchParams.set('resources[type]', 'collection');
    url.searchParams.set('resources[limit]', '10');
    url.searchParams.set('resources[limit_scope]', 'each');
    url.searchParams.set('resources[options][fields]', 'title');

    const response = await fetch(url.toString(), {
      headers: {
        Accept: 'application/json',
      },
    });

    if (!response.ok) {
      throw new Error(`HTTP ${response.status}`);
    }

    const data = await response.json();

    return (
      data &&
      data.resources &&
      data.resources.results &&
      Array.isArray(data.resources.results.collections)
        ? data.resources.results.collections
        : []
    );
  }

  async findCollectionRedirect(query = this.getQuery()) {
    const candidates = this.getCollectionCandidates(query);

    if (!candidates.length) {
      return null;
    }

    /*
     * Primero aprovechamos las colecciones que el predictive ya renderizó.
     * Esto evita una petición extra en la mayoría de búsquedas.
     */
    const renderedMatch = this.findCollectionInRenderedPredictive(candidates);

    if (renderedMatch && renderedMatch.url) {
      return renderedMatch.url;
    }

    /*
     * Si todavía no hay resultados predictive utilizamos el endpoint JSON.
     * Consultamos primero lo que escribió el usuario y, si pertenece a un
     * grupo de sinónimos, también el término principal del grupo.
     */
    const synonymGroup = this.getSynonymGroup(query);
    const lookupTerms = [query];

    if (synonymGroup && synonymGroup.length) {
      const canonical = synonymGroup[0];

      if (
        this.normalizeComparableSearchValue(canonical) !==
        this.normalizeComparableSearchValue(query)
      ) {
        lookupTerms.push(canonical);
      }
    }

    for (const lookupTerm of lookupTerms) {
      try {
        const collections = await this.fetchCollectionSuggestions(lookupTerm);
        const match = this.findBestCollectionMatch(collections, candidates);

        if (match && match.url) {
          return match.url;
        }
      } catch (error) {
        console.warn(
          '[Dislicores search] No se pudo validar colección para:',
          lookupTerm,
          error
        );
      }
    }

    return null;
  }

  async onSubmit(event) {
    const query = this.getQuery();

    if (!query || !this.form) {
      return;
    }

    event.preventDefault();

    if (this._isSubmitting) {
      return;
    }

    this._isSubmitting = true;

    try {
      /*
       * 1) Si la consulta coincide exactamente o es MUY parecida a una
       * colección, vamos directo a la colección.
       */
      const collectionUrl = await this.findCollectionRedirect(query);

      if (collectionUrl) {
        window.location.assign(collectionUrl);
        return;
      }

      /*
       * 2) Si no hay colección:
       *    - sinónimo -> expansión por título
       *    - vendor exacto -> vendor
       *    - resto -> solo palabras completas en title
       */
      const synonymGroup = this.getSynonymGroup(query);
      const exactVendor = synonymGroup ? null : this.getExactVendor(query);
      const allowTitlePrefix =
        !synonymGroup &&
        !exactVendor &&
        this.shouldUseTitlePrefix(query);

      const { searchTerm } = this.buildSearchTerm(query, {
        allowTitlePrefix,
      });

      if (!searchTerm) {
        return;
      }

      const url = new URL(this.form.action, window.location.origin);
      const formData = new FormData(this.form);

      for (const [key, value] of formData.entries()) {
        if (
          key === 'q' ||
          key === 'type' ||
          key === 'display_q' ||
          key === 'options[prefix]'
        ) {
          continue;
        }

        url.searchParams.append(key, value);
      }
      /*
      * Búsqueda normal:
      * Desde 4 letras dejamos que Shopify haga el prefix search nativo.
      *
      * Sinónimos y vendor:
      * Conservan nuestra consulta construida.
      */
      if (!synonymGroup && !exactVendor && allowTitlePrefix) {
        url.searchParams.set('q', query);
        url.searchParams.set('options[prefix]', 'last');
      } else {
        url.searchParams.set('q', searchTerm);
        url.searchParams.set('options[prefix]', 'none');
      }

      url.searchParams.set('type', 'product');

      /*
       * Solo es para mostrar al cliente lo que realmente escribió.
       * Shopify ignora este parámetro para la búsqueda.
       */
      url.searchParams.set('display_q', query);

      window.location.assign(url.toString());
    } finally {
      /*
       * Si location.assign navega correctamente este código no llega a ser
       * relevante. Si la navegación falla, permitimos intentar de nuevo.
       */
      window.setTimeout(() => {
        this._isSubmitting = false;
      }, 800);
    }
  }

  handleSearchKeywordClick(event) {
    const keywordLink = event.target.closest(
      '.search__most-searched-keywords a'
    );

    if (!keywordLink || !this.contains(keywordLink) || !this.form) {
      return;
    }

    const keyword = keywordLink.textContent.trim();

    if (!keyword) {
      return;
    }

    event.preventDefault();
    this.input.value = keyword;

    if (typeof this.form.requestSubmit === 'function') {
      this.form.requestSubmit();
    } else {
      this.form.dispatchEvent(
        new Event('submit', { bubbles: true, cancelable: true })
      );
    }
  }

  onFocus(event) {
    document.documentElement.style.setProperty('--viewport-height', `${window.innerHeight}px`);
    document.documentElement.style.setProperty(
      '--header-bottom-position',
      `${parseInt(this.header.getBoundingClientRect().bottom)}px`
    );

    if (this.isHeaderSearch && !this.searchRecommendationEmpty) {
      document.body.classList.add('search-open');
      this.toggleNavButtonVisibility(false);
    }

    if (!this.searchRecommendationEmpty) {
      this.searchContent.classList.remove('hidden');
    }

    this.classList.add('predictive-search-open');

    if (this.getQuery().length === 0) {
      if (this.searchRecommendationEmpty) {
        this.searchContent.classList.add('hidden');
      }
      return;
    }

    const url = this.setupURL().toString();
    this.renderSection(url, event);
  }

  getQuery() {
    return this.input.value.trim();
  }

  clear(event = null) {
    event?.preventDefault();
    this.input.value = '';
    this.input.focus();
    this.removeAttribute('results');
    this.toggleSearchState(false);
  }

  handleProductTypeChange(evt) {
    const query = this.getQuery();

    if (query.length > 0) {
      const url = this.setupURL().toString();
      this.renderSection(url);
    }
  }

  setupURL() {
    const url = new URL(`${window.shopUrl}${FoxTheme.routes.predictive_search_url}`);
    const { exactVendor, synonymGroup, searchTerm } =
      this.buildPredictiveSearchTerm();

    url.searchParams.set('q', searchTerm);

    /*
     * Buscador orientado a producto:
     * - búsquedas normales/sinónimos: productos + colecciones
     * - vendor exacto: productos
     */
    url.searchParams.set(
      'resources[type]',
      exactVendor ? 'product' : 'product,collection'
    );

    url.searchParams.set(
      'resources[limit]',
      this.dataset.resultsLimit || 3
    );

    url.searchParams.set(
      'resources[limit_scope]',
      'each'
    );

    /*
     * Campos del predictive:
     * - vendor exacto: title + vendor
     * - sinónimos: title
     * - normal: title + SKU si está habilitado desde el editor
     */
    let predictiveFields = 'title';

    if (exactVendor) {
      predictiveFields = 'title,vendor';
    } else if (!synonymGroup && this.skuSearchEnabled) {
      predictiveFields = 'title,variants.sku';
    }

    url.searchParams.set(
      'resources[options][fields]',
      predictiveFields
    );

    url.searchParams.set(
      'resources[options][unavailable_products]',
      'last'
    );

    url.searchParams.set(
      'section_id',
      FoxTheme.utils.getSectionId(this)
    );

    return url;
  }

  onChange() {
    if (this.getQuery().length === 0) {
      this.clear();
      return;
    }

    const url = this.setupURL().toString();
    this.renderSection(url);
  }

  renderSection(url) {
    this.cachedMap.has(url)
      ? this.renderSectionFromCache(url)
      : this.renderSectionFromFetch(url);
  }

  renderSectionFromCache(url) {
    const responseText = this.cachedMap.get(url);
    this.renderSearchResults(responseText);
    this.setAttribute('results', '');
  }

  renderSectionFromFetch(url) {
    this.setLoadingState(true);

    fetch(url)
      .then((response) => {
        if (!response.ok) throw new Error('Network response was not ok');
        return response.text();
      })
      .then((responseText) => {
        this.renderSearchResults(responseText);
        this.cachedMap.set(url, responseText);
      })
      .catch((error) => {
        console.error('Error fetching data: ', error);
        this.setAttribute('error', 'Failed to load data');
      })
      .finally(() => this.setLoadingState(false));
  }

  titleContainsWholePhrase(title, phrase) {
    const normalizedTitle = this.normalizeComparableSearchValue(title);
    const normalizedPhrase = this.normalizeComparableSearchValue(phrase);

    if (!normalizedTitle || !normalizedPhrase) {
      return false;
    }

    return (` ${normalizedTitle} `).includes(` ${normalizedPhrase} `);
  }

  titleContainsWordStartingWith(title, prefix) {
    const normalizedTitle = this.normalizeComparableSearchValue(title);
    const normalizedPrefix = this.normalizeComparableSearchValue(prefix);

    if (!normalizedTitle || !normalizedPrefix || normalizedPrefix.length < 4) {
      return false;
    }

    const titleWords = normalizedTitle.split(' ').filter(Boolean);

    return titleWords.some((word) => word.startsWith(normalizedPrefix));
  }

  getUnitSkus(unit) {
    if (!unit) {
      return [];
    }

    const raw = unit.getAttribute('data-dislicores-skus');

    if (!raw) {
      return [];
    }

    try {
      const parsed = JSON.parse(raw);

      return Array.isArray(parsed)
        ? parsed.map((sku) => String(sku || '').trim()).filter(Boolean)
        : [];
    } catch (error) {
      console.warn('[Dislicores search] No se pudieron leer los SKU del producto.', error);
      return [];
    }
  }

  productMatchesCurrentQuery(unit) {
    const titleElement = unit.querySelector('.product-card__title');

    if (!titleElement) {
      return true;
    }

    const title = titleElement.textContent;
    const query = this.getQuery();
    const synonymGroup = this.getSynonymGroup(query);

    /*
     * Los vendor exactos conservan el comportamiento anterior:
     * la coincidencia puede venir del vendor aunque el nombre no aparezca
     * literalmente en el título.
     */
    if (!synonymGroup && this.getExactVendor(query)) {
      return true;
    }

    /*
     * Los sinónimos son una expansión editorial del nombre del producto.
     * Por eso siguen validándose exclusivamente contra el título.
     */
    if (synonymGroup) {
      return synonymGroup.some((term) =>
        this.titleContainsWholePhrase(title, term)
      );
    }

    const normalizedQuery = this.normalizeComparableSearchValue(query);
    const words = normalizedQuery.split(' ').filter(Boolean);

    const lastIndex = words.length - 1;

    const titleMatches =
      words.length === 0 ||
      words.every((word, index) => {
        if (index === lastIndex && word.length >= 4) {
          return this.titleContainsWordStartingWith(title, word);
        }

        return this.titleContainsWholePhrase(title, word);
      });

    if (titleMatches) {
      return true;
    }

    /*
     * Si la búsqueda por SKU está activa, aceptamos también coincidencia
     * exacta (sin distinguir mayúsculas/minúsculas) contra cualquier variante.
     */
    if (this.skuSearchEnabled) {
      const normalizedSkuQuery = this.normalizeSkuValue(query);
      const skus = this.getUnitSkus(unit);

      return skus.some(
        (sku) => this.normalizeSkuValue(sku) === normalizedSkuQuery
      );
    }

    return false;
  }

  filterPredictiveProducts(root) {
    const list = root.querySelector('#predictive-search-results-products-list');

    if (!list) {
      return;
    }

    Array.from(list.children).forEach((unit) => {
      if (!this.productMatchesCurrentQuery(unit)) {
        unit.remove();
      }
    });

    if (!list.children.length) {
      const productSection = list.closest('.predictive-search-result--products');

      if (productSection) {
        productSection.remove();
      }
    }
  }

  renderSearchResults(responseText) {
    const id = 'PredictiveSearchResults-' + FoxTheme.utils.getSectionId(this);

    // IMPORTANTE:
    // Buscar el contenedor dentro de ESTE predictive-search,
    // no globalmente en todo el documento.
    const targetElement = this.querySelector(`[id="${id}"]`);

    if (!targetElement) {
      console.error(`Element with id '${id}' not found inside this predictive-search.`);
      return;
    }

    const parser = new DOMParser();
    const parsedDoc = parser.parseFromString(responseText, 'text/html');
    const contentElement = parsedDoc.getElementById(id);

    if (!contentElement) {
      console.error(`Element with id '${id}' not found in the parsed response.`);
      return;
    }

    this.searchContent?.classList.remove('hidden');

    targetElement.innerHTML = contentElement.innerHTML;

    /*
     * Predictive Search aplica su propia tolerancia/partial matching.
     * Filtramos el HTML final para garantizar la regla Dislicores:
     * productos solo si hay coincidencia válida por:
     * - título con palabras completas,
     * - sinónimo configurado, o
     * - SKU exacto cuando la opción está habilitada.
     */
    this.filterPredictiveProducts(targetElement);

    if (window.SucursalProductPriority) {
      window.SucursalProductPriority.refreshWithin(targetElement);
    }

    if (this.isHeaderSearch && !document.body.classList.contains('search-open')) {
      document.body.classList.add('search-open');
      this.toggleNavButtonVisibility(true);
    }

    this.classList.add('predictive-search-open');
  }

  handleClickOutside(event) {
    const target = event.target;
    const shouldClose = this.isHeaderSearch
      ? !this.contains(target) &&
        ((target.classList.contains('fixed-overlay') && target.closest('.header-section')) ||
          target.classList.contains('header__search-close'))
      : !this.contains(target);

    if (shouldClose) {
      setTimeout(() => this.toggleSearchState(false));
    }
  }

  toggleSearchState(isOpen) {
    this.classList.toggle(this.states.OPEN, isOpen);

    if (this.isHeaderSearch) {
      document.body.classList.toggle(this.states.SEARCH_OPEN, isOpen);
      this.toggleNavButtonVisibility(!isOpen);
    }

    if (!isOpen && this.searchRecommendationEmpty) {
      this.searchContent?.classList.add('hidden');
    }
  }

  toggleNavButtonVisibility(isOpen) {
    this.toggleNavigationButton &&
      this.toggleNavigationButton.classList.toggle('is-show', isOpen);
  }

  setLoadingState(isLoading) {
    if (isLoading) {
      this.setAttribute('loading', 'true');

      if (this.resetButton) {
        this.resetButton.classList.add(this.states.LOADING);
      }
    } else {
      this.removeAttribute('loading');

      if (this.resetButton) {
        this.resetButton.classList.remove(this.states.LOADING);
      }

      this.setAttribute('results', 'true');
    }
  }
}

if (!customElements.get('predictive-search')) {
  customElements.define('predictive-search', PredictiveSearch);
}


/* ===== DISLICORES: ejecutar prioridad en search inicial y rerenders ===== */
(function () {
  function refreshSearchProducts() {
    if (!window.SucursalProductPriority) return;
    window.SucursalProductPriority.refreshWithin(document);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', refreshSearchProducts);
  } else {
    refreshSearchProducts();
  }

  // facets.js reemplaza #ProductGridContainer por AJAX.
  document.addEventListener('collection:rerendered', function () {
    refreshSearchProducts();
  });

  // Si la pagina no se recarga al cambiar sucursal (header/home), revalidamos
  // cualquier predictive search que siga abierto.
  document.addEventListener('sucursal:changed', function () {
    if (!window.SucursalProductPriority) return;
    window.SucursalProductPriority.clearCache();
    refreshSearchProducts();
  });
})();
